export default url
export const {
  URL,
  URLSearchParams,
  Url,
  domainToASCII,
  domainToUnicode,
  format,
  parse,
  resolve,
} = url